export enum REVIEWS_SDK_EVENTS {}

export enum REVIEWS_SDK_METHODS {
    OPEN_REVIEWS_DRAWER = "openReviewsDrawer",
    CLOSE_REVIEWS_DRAWER = "closeReviewsDrawer",
    GET_REVIEWS = "getReviews",
    GET_REVIEWS_STATE_KIT = "getReviewsStateKit",
}
